module.exports = __webpack_public_path__ + "static/media/babyswap-logo.c12af33c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pc/babyswap-logo.png
// module id = 317
// module chunks = 0